<template>
    <input type="password"
        v-model="current_value"
        class="form-control tip"
        :required="field.required"
        :readonly="field.readonly"
        :disabled="field.disabled"
        :data-original-title="field.help"
        data-placement="bottom"
        data-toggle="tooltip"
        :placeholder="field.placeholder"
        @input="updateFromPassword">
</template>

<script>
    export default {
        name: "CustomPassword",

        props: [
            "field", "value", "field_idx"
        ],

        data() {
            return {
                current_value: this.value,
            }
        },

        methods: {
            updateFromPassword() {
                this.$emit("field-updated", {type:this.field.type, idx:this.field_idx, new_value:this.current_value})
            }
        },

        watch: {
            value (newv, oldv) {
                this.current_value = newv
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Password.vue